import { validateAddress } from '../utils/helpers.mjs';
import { soundEditionV1_2Abi } from '../abi/sound-edition-v1_2.mjs';
import { interfaceIds } from '@soundxyz/sound-protocol';
import { NotSoundEditionError } from '../errors.mjs';

async function isSoundEdition({
  editionAddress
}) {
  const { instance } = this;
  return instance.idempotentCachedCall(`is-sound-edition-${editionAddress}`, async () => {
    validateAddress(editionAddress, { type: "SOUND_EDITION" });
    const client = await this.expectClient();
    try {
      return await client.readContract({
        abi: soundEditionV1_2Abi,
        address: editionAddress,
        functionName: "supportsInterface",
        args: [interfaceIds.ISoundEditionV1]
      });
    } catch (err) {
      if (err instanceof Error && "code" in err && err.code === "CALL_EXCEPTION") {
        return false;
      }
      throw err;
    }
  });
}
function validateSoundEdition({ editionAddress, assumeValidSoundContract }) {
  if (assumeValidSoundContract)
    return;
  return isSoundEdition.call(this, { editionAddress }).then((isEdition) => {
    if (!isEdition)
      throw new NotSoundEditionError({ contractAddress: editionAddress });
  });
}
async function getNetworkChainId() {
  const client = await this.expectClient();
  return client.chain?.id;
}
async function networkChainMatches({ chainId }) {
  const networkChain = await getNetworkChainId.call(this);
  return networkChain === chainId;
}

export { isSoundEdition, networkChainMatches, validateSoundEdition };
